import React from "react";
import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ArtGallery from "../images/art-gallery.jpg"; // Import your artist image
import DigitalWoman from "../images/digital-old-woman-2025.jpg";
import GalleryInterior from "../images/gallery-interior-2025.jpg";
import WomanHeadDress from "../images/woman-head-dress-2025.jpg";
import Splash from "../components/Splash";

const Home = ({ user }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const hiddenElements = document.querySelectorAll(".slideUp");
    console.log("hidden elements", hiddenElements);

    const observerOptions = {
      root: null, // using the viewport as the root
      threshold: 0.2, // trigger when 50% of the target is visible
      rootMargin: "0px", // adjust this value to fine-tune when the observer triggers
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log("HomeShow", entry);
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    }, observerOptions);

    hiddenElements.forEach((el) => observer.observe(el));

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []); // Empty dependency array to run only on mount

  return (
    <>
      <Splash className='slideUp' />
      <Container id='targetSection' className='mt-3'>
        <Row className='mt-3 d-flex align-items-center'>
          <h1 className='whiteText'>Welcome</h1>
          <Col lg={{ span: 6, order: 1 }} className='whiteText slideUp'>
          <p>
  Exciting news! The Piermont Flywheel Gallery will present two thrilling Guest Artist Showcases at the end of the year in November and December—each a 4-week opportunity to exhibit your work and connect with new audiences.
</p>
<p>
  We're committed to promoting your art. Our experienced member team will support you in organizing your exhibit and help you host an engaging reception to celebrate your creativity.
</p>

          </Col>
          <Col lg={{ span: 6, order: 2 }} className='text-center slideUp'>
            <img
              src={GalleryInterior}
              alt='Artist Showcase'
              className='img-fluid'
            />
          </Col>
        </Row>

        <Row className='mt-3 d-flex align-items-center'>
          {/* Text first on small screens, second on large screens */}
          <Col
            lg={{ span: 6, order: 2 }} // Order 2 on large screens (below image)
            sm={{ span: 12, order: 1 }} // Order 1 on small screens (above image)
            className='whiteText mt-4 slideUp'
          >
            <h2>Grow as an Artist - Sell Your Work</h2>
            <p>
              You have control over your prices and keep 100% of your individual sales
              (minus credit card fees if applicable). There's a nominal fee to apply, and if you're selected, the one-time fee is just $450.
            </p>
            <p>
              Participating artists will take turns gallery sitting during their show,
              ensuring equal participation.
            </p>
            <p>
              We welcome all art forms and mediums, from classic paintings to innovative
              digital installations, fine art photography, mixed media, and
              three-dimensional artworks (sculpture, pottery, etc.).
            </p>
          </Col>

          {/* Image second on small screens, first on large screens */}
          <Col
            lg={{ span: 6, order: 1 }} // Order 1 on large screens (above text)
            sm={{ span: 12, order: 2 }} // Order 2 on small screens (below text)
            className='text-center slideUp'
          >
            <img src={DigitalWoman} alt='Artist Showcase' className='img-fluid' />
          </Col>
        </Row>

        <Row className='mt3 d-flex align-items-center'>
          <Col lg={{ span: 6, order: 1 }} sm={{ span: 12, order: 2 }} className='whiteText mt-4 slideUp'>
            <h2>Don't Miss Out</h2>
            <p>
              The deadline for submissions will be announced shortly. Once the
              finalists are selected, we'll reach out to you directly with all
              the details leading up to your show.
            </p>
            <p>
              Our jury of gallery member artists will select works based on
              quality of work, medium, size and the number of participating
              artists. Each featured artist will have equal space in our
              North Gallery.
            </p>
            {!user && (
              <p>
                It's easy to get started! Be sure to read and accept our terms
                and conditions document after you register.
              </p>
            )}
            {!user && (
              <p>
                We can't wait to see your incredible art grace our gallery! Get
                those submissions in, and let's create two shows to remember.
                🎨✨
              </p>
            )}{" "}
            {!user && (
              <Button
                className='btn btn-primary mb-4'
                onClick={() => navigate("/Register")}>
                Register to Get Started
              </Button>
            )}
          </Col>

          <Col
            lg={{ span: 6, order: 2 }}  // Order 2 on large screens
            sm={{ span: 12, order: 1 }} // Order 1 on small screens (first)
            className='whiteText slideUp'
          >
            <img src={WomanHeadDress} alt='Artist Showcase' className='img-fluid' />
          </Col>
        </Row>

        <Row className='mt-3 d-flex align-items-left'>
          <Col lg={4} className='whiteText'></Col>
          <Col lg={4} className='whiteText'>
            {" "}
          </Col>
          <Col lg={4} className='whiteText'>
            {" "}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;
